export default class BoardPrintType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}
